/* Copyright (c) 2025 Xperi. All Rights Reserved. */
import React, { ComponentProps, ComponentType, memo, MemoExoticComponent } from 'react';

/**
 * Wrap a component with React.memo, optionally using a custom comparator.
 *
 * @param Component - The component to memoize.
 * @param areEqual - Optional custom props comparator.
 * @returns Memoized component.
 */
function TiVoMemo<T extends ComponentType<any>>(
    Component: T,
    areEqual?: (
        prevProps: Readonly<ComponentProps<T>>,
        nextProps: Readonly<ComponentProps<T>>,
    ) => boolean,
): MemoExoticComponent<T> {
    return memo(Component, areEqual);
}

export { TiVoMemo };
